<template>
  <v-container>
    <v-snackbar v-model="msge" :timeout="4000" top color="white">
      <span :class="color">{{msg}}</span>
      <v-icon @click="msge = false" :color="color">mdi-close</v-icon>
    </v-snackbar>
    <v-row>
            <v-dialog v-model="showDialog" max-width="600">
                <v-card>
                    <v-system-bar flat color="white">
                        <v-spacer></v-spacer>
                        <v-btn text class="mt-3" style="color:#B45C5C" @click="showDialog=false">Close <v-icon small right>mdi-close</v-icon></v-btn>
                    </v-system-bar>
                    <v-card-text class="text-center headline mt-6" style="color:#48c074;">Transaction Details</v-card-text>
                    <v-card-text>
                    <v-simple-table>
                        <template v-slot:default>
                        <thead>
                            <tr>
                            <th class="text-center black--text">Attribute</th>
                            <th class="text-center black--text">Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="text-center">Amount</td>
                                <td class="text-center">&#8358;{{showTrans.amount}}</td>
                            </tr>
                            <tr>
                                <td class="text-center">Estimated Return</td>
                                <td class="text-center">{{showTrans.estimated_return}}</td>
                            </tr>
                            <tr>
                                <td class="text-center">Investment Code</td>
                                <td class="text-center">{{showTrans.investment_code}}</td>
                            </tr>
                            
                            <tr>
                                <td class="text-center">Units Bought</td>
                                <td class="text-center">{{showTrans.units_bought}}</td>
                            </tr>
                            
                            <tr>
                                <td class="text-center">Payment Ref</td>
                                <td class="text-center">{{showTrans.transRef}}</td>
                            </tr>
                            <tr>
                                <td class="text-center">Status</td>
                                <td class="text-center">{{showTrans.status}}</td>
                            </tr>
                            <tr>
                                <td class="text-center">Date Paid</td>
                                <td class="text-center">{{showTrans.date_paid}}</td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    
                    
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    <v-toolbar flat>
      <h3 class="mt-7">My Profile</h3>
      <v-spacer></v-spacer>
      <v-btn rounded color="red" dark v-if="isActive===true" @click="DeactivateUser($event)" :loading="loading">Deactivate</v-btn>
      <v-btn rounded color="green" dark v-if="isActive===false" @click="ActivateUser($event)" :loading="loading">Activate</v-btn>
    </v-toolbar>
    <div class="mx-5">
      <v-tabs color="#48c074" background-color="transparent">
      <v-tab>General Info</v-tab>
      <v-tab> Transactions</v-tab>
      <!-- first tab -->
      <v-tab-item>
          <v-row justify="center" align="center">
              <div class="mx-auto">
                  <v-avatar size="120" class="mx-auto">
                      <v-img dark src="/pics.svg"></v-img>
                  </v-avatar>
              </div>
          </v-row>
        <v-row>
          <v-col cols="12" md="6" sm="12">
            <div class="form-group">
              <label for="name">Name</label>
              <div class="input-group">
                <input type="text" readonly id="name" class="form-control"  v-model="name">
              </div>
            </div>
            <div class="form-group">
              <label for="email">Email</label>
              <div class="input-group">
                <input type="text" readonly id="email" class="form-control"  v-model="email">
              </div>
            </div>
            <div class="form-group">
              <label for="phone">Phone Number</label>
              <div class="input-group">
                <input type="text" readonly  id="phone" class="form-control"  v-model="phone">
              </div>
            </div>
            <div class="form-group">
              <label for="name">First Name</label>
              <div class="input-group">
                <input type="text" readonly id="fname" class="form-control"  v-model="fname">
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="6" sm="12">
            <div class="form-group">
              <label for="bankname">Bank Name</label>
              <div class="input-group">
                <input type="text" readonly id="bankname" class="form-control"  v-model="bankname">
              </div>
            </div>
            <div class="form-group">
              <label for="accountname">Account Name</label>
              <div class="input-group">
                <input type="text" readonly id="accountname" class="form-control"  v-model="accountname">
              </div>
            </div>
            <div class="form-group">
              <label for="accountnumber">Account Number</label>
              <div class="input-group">
                <input type="text" readonly id="accountnumber" class="form-control"  v-model="accountnumber">
              </div>
            </div>
            <div class="form-group">
              <label for="name">Last Name</label>
              <div class="input-group">
                <input type="text" readonly id="lname" class="form-control"  v-model="lname">
              </div>
            </div>
          </v-col>
        </v-row>
        
        <hr>
        <!-- Investments -->
        <h5 class="mt-5" style="color:#48c074">All Investments</h5>
        <v-card class="mb-12">
          <template>
              <v-data-table
                  :headers="headers"
                  :items="Investment"
                  hide-default-footer=""
                  no-data-text='You have no current investments'
                  >
                  <template v-slot:item.action="{ item }">
                      <v-btn text color="#48c074" @click="getInvestmentById(item._id)" style="border: 1px #48c074 solid; color:#48c074" class="text-none">View</v-btn>
                  </template>
                  <template v-slot:item.cost="{ item }">
                      <span class="black--text">&#8358;{{item.cost}}</span>
                  </template>
                  <template v-slot:item.roi="{ item }">
                      <span class="black--text">{{item.roi}}%</span>
                  </template>
              </v-data-table>
          </template>
        </v-card>
      </v-tab-item>
      <!-- second tab -->
      <v-tab-item>
        <v-row class="mt-3">
                  <v-col>
                      <v-card>
                          <v-card-title style="color:#48c074">
                              Recent Transactions
                          </v-card-title>
                          <v-data-table
                              :headers="transHeaders"
                              :items="Transactions"
                              hide-default-footer=""
                              :items-per-page="5"
                              no-data-text='No Recent Transaction For Display'
                              >
                              <template v-slot:item.status="{ item }">
                                  <span class="black--text">{{item.status}}</span>
                              </template>
                              <template v-slot:item.desc="{ item }">
                                  <span class="black--text">{{item.description}}</span>
                              </template>
                              <template v-slot:item.type="{ item }">
                                  <span class="black--text">{{item.paymentType}}</span>
                              </template>
                              <template v-slot:item.date="{ item }">
                                  <span class="black--text">{{item.datePerformed}}</span>
                              </template>
                              <template v-slot:item.amount="{ item }">
                                  
                                  <span class="black--text">&#8358;{{item.amount}}</span>
                              </template>
                               <template v-slot:item.estimated_return="{ item }">
                                  
                                  <span class="black--text">&#8358;{{item.estimated_return}}</span>
                              </template>
                              <template v-slot:item.action="{ item }">
                                  <v-btn text @click="show(item)" style="border: 1px #48c074 solid; color:#48c074" class="text-none" small>View</v-btn>
                              </template>
                          </v-data-table>
                      </v-card>
                  </v-col>
              </v-row>
      </v-tab-item>
    </v-tabs>
    </div>
      

    
  </v-container>
</template>

<script>
export default {
  data(){
    return{
      name: this.$store.state.users.usersbyid.firstname + " " + this.$store.state.users.usersbyid.lastname,
      lname: this.$store.state.users.usersbyid.lastname,
      fname: this.$store.state.users.usersbyid.firstname,
      email: this.$store.state.users.usersbyid.email,
      phone: this.$store.state.users.usersbyid.phone,
      bankname: this.$store.state.users.usersbyid.bank_name,
      accountnumber: this.$store.state.users.usersbyid.account_number,
      accountname: this.$store.state.users.usersbyid.account_name,
      // isActive: this.$store.state.users.usersbyid.isActive,
      show1:false,
      show2:false,
      show3:false,
      oldPassword:'',
      newPassword:'',
      cpassword:'',
      headers: [
            {
            text: 'Farm',
            align: 'start',
            sortable: false,
            value: 'name',
            },
            { text: 'Cost', value: 'cost' },
            { text: 'ROI', value: 'roi' },
            { text: 'Duration', value: 'duration' },
            { text: 'Date Added', value: 'date_created' },
            { text: '', value: 'action' },
        ],
        investments:[
          {name:'Poultry', duration:'3 months', cost:'90,000', roi:'30%', status:'Invested', date_created:'2020-09-08 09:30:01'}
        ],
          transHeaders: [
            {
              text: 'Amount',
              align: 'start',
              sortable: false,
              value: 'amount',
          },
          { text: 'Status', value: 'status' },
          { text: 'Estimated Return', value: 'estimated_return' },
          { text: 'Date Paid', value: 'date_paid' },
          { text: '', value: 'action' },
          
        
        ],
        trans:[
            {amount:'90,000', description:'Investment Payment', status:'Sucessful', trans_type:'Wallet Top Up', date_performed:'2020-09-08 08:15:03'}
        ],
        showDialog:false,
        showTrans:{},
        loading:false,
        msge:false,
        msg:'',
        color:''
    }
  },
  computed: {
     Investment(){
          let user= this.$store.state.farm.investment
        for(let i=0; i<user.length; i++){
            user[i].date_created = user[i].date_created.slice(0, 19).replace('T', ' ')
            user[i].cost = parseFloat(user[i].cost).toFixed(2)
            user[i].cost = user[i].cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      return user
        },
      Transactions(){
        let trans= this.$store.state.farm.transactions
        for(let j=0; j<trans.length; j++){
          trans[j].date_paid = trans[j].date_paid.slice(0, 19).replace('T', ' ')
          trans[j].amount = parseFloat(trans[j].amount).toFixed(2)
          trans[j].amount = trans[j].amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          trans[j].estimated_return = parseFloat(trans[j].estimated_return).toFixed(2)
          trans[j].estimated_return = trans[j].estimated_return.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return trans
        },
        isActive(){
         return this.$store.state.users.usersbyid.isActive
        }
  },
  methods:{
    getInvestmentById(id){
       this.$store.dispatch("GetInvestmentById", id)
          .then(()=>{     
              this.$router.push('/admin/invest/'+id)
          })
          .catch(()=>{
          });
    },
    show(item){
        this.showTrans=item
        this.showDialog=true
    },
    ActivateUser(event){
      event.preventDefault()
          this.loading = true
            this.$store.dispatch("ActivateUser", this.$store.state.users.usersbyid._id)
            .then(()=>{
              this.$store.dispatch("GetUsersById",this.$store.state.users.usersbyid._id)
            this.loading= false
            this.msg="User successfully activated"
            this.color='green--text'
            this.msge = true
            // cogoToast.success('farm activated!')
            
          })
          .catch((error)=>{
            this.loading= false
            this.msg= error.response.data.message
            this.color='red--text'
            this.msge =true
          });
    },
      DeactivateUser(event){
      event.preventDefault()
          this.loading = true
            this.$store.dispatch("DeactivateUser",this.$store.state.users.usersbyid._id)
            .then(()=>{
            this.$store.dispatch("GetUsersById",this.$store.state.users.usersbyid._id )
            this.loading= false
            //  cogoToast.success('farm deactivated!')
            
            this.msg="User successfully deactivated"
            this.color='green--text'
            this.msge = true
          })
          .catch((error)=>{
            this.loading= false
            this.msg= error.response.data.message
            this.color='green--text'
            this.imsge =true
          });
    }
  },
  created(){
    this.$store.dispatch("GetUsersInvestment",{id:this.$store.state.users.usersbyid._id})
      .then(()=>{ 
      })
      .catch(()=>{
      });

      this.$store.dispatch("GetTransactions",{id:this.$store.state.users.usersbyid._id})
          .then(()=>{ 
          })
          .catch(()=>{
          });
  }
}
</script>

<style>

</style>